import { NonContentBlocks } from 'common/builder/components/chart/FlowChart/lib/constants/NonContentBlocks'
import { FlowChartBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'

export function hasContentBlocks(blocks: FlowChartBlock[]): boolean {
  return blocks.filter((block) => !NonContentBlocks.includes(block?.type)).length > 0
}
